import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import PropertyEntry from './components/PropertyEntry';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PropertyEntry />
  </React.StrictMode>
);
